import axios from "axios";
import { pushUnlocks } from "@/components/AchievementBanner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Legacy fallback: pre-cookie sessions still carry zu_token in storage.
// New logins rely purely on the httpOnly cookie and never store the token.
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("zu_token") || sessionStorage.getItem("zu_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Surface achievement unlocks AND morale-band events attached to any response.
api.interceptors.response.use((res) => {
  const unlocks = res?.data?.newly_earned_achievements;
  if (Array.isArray(unlocks) && unlocks.length) pushUnlocks(unlocks);
  const events = res?.data?.morale_events;
  if (Array.isArray(events) && events.length) {
    // Lazy-import sonner to avoid circular dep
    import("sonner").then(({ toast }) => {
      events.forEach((ev) => {
        toast(ev.message, {
          duration: 7000,
          className: "morale-event-toast",
          description: "ENEMY MORALE COLLAPSING",
        });
      });
    });
  }
  return res;
});

export const getStoredAuth = () => {
  try {
    const a = localStorage.getItem("zu_auth") || sessionStorage.getItem("zu_auth");
    return a ? JSON.parse(a) : null;
  } catch {
    return null;
  }
};

export const setStoredAuth = (auth, remember = true) => {
  // Clear both stores first to avoid stale state when toggling remember-me
  localStorage.removeItem("zu_auth");
  localStorage.removeItem("zu_token");
  sessionStorage.removeItem("zu_auth");
  sessionStorage.removeItem("zu_token");
  if (auth) {
    // Token lives in an httpOnly cookie now — persist only user info.
    const { token, ...userInfo } = auth;
    const store = remember ? localStorage : sessionStorage;
    store.setItem("zu_auth", JSON.stringify(userInfo));
  }
};
